export default "__VITE_ASSET__CwXXgCBJ__"